import { FreeSpinsPaysAct as BaseFreeSpinsPaysAct } from "onearm";

/**
 * @description Fix for double win crediting in free spins WIN counter.
 * onearm ставит baseline большого счётчика = getFreeSpinsTotalWin() (кумулятив, уже
 * включающий выигрыш текущего спина), а затем доначисляет pay.win поверх → двойной счёт.
 * Откручиваем baseline на выигрыш текущего спина и добавляем внутриспинное накопление,
 * чтобы несколько pay-шагов одного каскадного спина стыковались без сброса счётчика.
 */
export class FreeSpinsPaysAct extends BaseFreeSpinsPaysAct {
    constructor(params) {
        super(params);

        const totalWin = this.result.totalWin ?? 0; // тотал текущего спина (после множителя)
        const winBeforPay = this.result.winBeforPay ?? 0; // накоплено в спине до этого шага

        this.totalWin = this.gameLogic.getFreeSpinsTotalWin() - totalWin + winBeforPay;
    }
}
